exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox{\n    margin-top: 25px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/projects/create/create-project.component.css
// module id = ../../../../../src/app/projects/create/create-project.component.css
// module chunks = main